<div
  class="relative flex max-w-sm min-w-[288px] flex-col gap-2 overflow-hidden rounded-md border border-slate-600 bg-slate-700 px-4 py-3"
  [class.snack-paused]="paused()"
  (mouseenter)="onMouseEnter()"
  (mouseleave)="onMouseLeave()"
>
  <div class="flex items-center gap-3">
    <span class="flex shrink-0 items-center">
      <mat-icon style="color: #6ee7b7; font-size: 20px; width: 20px; height: 20px; line-height: 20px">check_circle</mat-icon>
    </span>
    <span class="flex-1 text-sm font-medium text-white" style="line-height: 20px">{{ data.successMessage }}</span>
    <button
      (click)="snackBarRef.dismiss()"
      class="flex shrink-0 cursor-pointer items-center justify-center p-0 text-slate-400 transition-colors duration-150 hover:text-white"
      style="background: none; border: none; outline: none; height: 20px"
    >
      <mat-icon style="color: inherit; font-size: 17px; width: 17px; height: 17px; line-height: 17px">close</mat-icon>
    </button>
  </div>

  <div class="flex items-center gap-3">
    <span class="flex shrink-0 items-center">
      <mat-icon style="color: #f87171; font-size: 20px; width: 20px; height: 20px; line-height: 20px">cancel</mat-icon>
    </span>
    <span class="flex-1 text-sm font-medium text-white" style="line-height: 20px">{{ data.failureMessage }}</span>
  </div>

  @if (data.duration > 0) {
    <div class="snack-progress-bar"></div>
  }
</div>
